import { useEffect, useState, createContext, useContext } from "react";
import { useRouter } from "next/router";
import { useRoles } from "./useRoles";
import { roles } from "../constants/roles";

const SourceContext = createContext();

function SourceProvider({ children }) {
  const {
    query: { source: querySource },
  } = useRouter();
  const [source, setSource] = useState("");
  const { roles: userRole, checkAccess } = useRoles();

  useEffect(() => {
    if (!querySource && !userRole) return;
    if (checkAccess(roles.salesSap)) {
      setSource("SAP");
    } else if (checkAccess(roles.marketing) && querySource === "SAP") {
      setSource("SAP");
    } else if (
      checkAccess(roles.sales) ||
      (checkAccess(roles.marketing) && querySource === "Squidex")
    ) {
      setSource("Squidex");
    } else {
      setSource("Squidex");
    }
  }, [querySource, userRole]);

  return (
    <SourceContext.Provider value={{ source, setSource }}>
      {children}
    </SourceContext.Provider>
  );
}

function useSource() {
  const context = useContext(SourceContext);

  if (context === undefined) {
    throw new Error("useSource must be used within a SourceProvider");
  }

  return context;
}

export { SourceProvider, useSource };
